var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHunterTourBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 39,
    viewBox: "0 0 92 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M90.0638 20.9671C88.644 25.0237 82.8634 28.6745 78.9083 28.9788C56.8001 30.7028 34.5903 30.7028 12.4822 28.9788C8.52704 28.6745 2.84812 25.0237 1.32692 20.9671C0.718439 19.1417 0.312524 17.3162 0.109697 15.4907C-0.194544 19.4459 0.109957 23.401 1.32692 27.2547C2.74671 31.9198 8.52704 36.2805 12.4822 36.5848C34.5903 38.613 56.8001 38.613 78.9083 36.5848C82.8634 36.1791 88.5426 31.9198 90.0638 27.2547C91.1794 23.2996 91.585 19.3444 91.2807 15.4907C91.0779 17.3162 90.6723 19.1417 90.0638 20.9671Z",
    fill: "#540B00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M79.0129 32.9342C56.9048 34.7597 34.6953 34.6583 12.5871 32.9342C8.63201 32.63 2.95279 28.9792 1.43158 24.9226C-0.393861 19.7505 -0.393861 14.5784 1.43158 9.40635C2.85137 5.3498 8.63201 1.69883 12.5871 1.39459C34.6953 -0.329445 56.9048 -0.329445 79.0129 1.39459C82.9681 1.69883 88.6473 5.3498 90.1685 9.40635C91.9939 14.5784 91.9939 19.7505 90.1685 24.9226C88.7487 28.9792 82.9681 32.63 79.0129 32.9342Z",
    fill: "url(#paint0_linear_6106_154339)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M2.84375 22.3866C10.5512 17.5188 18.2584 12.6509 26.0672 7.88442C30.8337 5.04484 35.7017 2.50961 40.7723 0.0756836C40.3667 0.0756836 39.8596 0.0756836 39.4539 0.0756836C33.6733 2.81385 27.9944 5.8562 22.518 9.20285C15.8247 13.2594 9.23281 17.6203 2.84375 22.2853V22.3866Z",
    fill: "url(#paint1_linear_6106_154339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M14.7109 32.3251C32.9654 20.8654 51.6255 9.91269 71.0969 0.785469C68.5615 0.684056 66.0262 0.481296 63.4909 0.379883C54.4651 5.34915 45.4393 10.4198 36.9205 16.3017C29.4159 21.4738 22.0127 26.7474 14.7109 32.3251Z",
    fill: "url(#paint2_linear_6106_154339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M85.2985 3.82746C85.2985 3.82746 84.8929 3.52329 84.6901 3.42188C77.2869 7.37701 69.8837 11.2307 62.4805 15.2872C69.9851 11.3321 77.5911 7.4783 85.2985 3.92882V3.82746Z",
    fill: "url(#paint3_linear_6106_154339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M62.0716 24.9223C71.3003 19.6488 80.7318 14.5782 90.3661 9.91312C90.3661 9.7103 90.2645 9.50734 90.1631 9.30451C90.1631 9.2031 90.0618 9.00034 89.9604 8.89893C76.1681 16.2007 62.2744 23.2996 49.5977 32.1226C53.7556 29.6886 57.9137 27.2548 62.0716 24.9223Z",
    fill: "url(#paint4_linear_6106_154339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M55.4852 0.177246C53.8626 0.177246 52.1383 0.177246 50.5157 0.177246C48.6903 0.988555 46.9663 1.79986 45.1408 2.71259C32.5655 8.69599 21.1058 15.795 9.34182 23.1982C7.11072 24.618 4.87969 26.0378 2.75 27.3562C4.16979 29.1816 6.40106 30.8041 8.63216 31.8182C16.8467 25.5306 25.3653 19.4458 33.8841 13.4624C40.8816 8.59455 48.1834 4.3352 55.4852 0.177246Z",
    fill: "url(#paint5_linear_6106_154339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M22.9274 0.68457C19.4794 0.887398 16.0314 1.09014 12.5834 1.39439C8.62823 1.69863 2.94901 5.3496 1.4278 9.40615C0.616493 11.9415 0.109375 14.3753 0.109375 16.9107C7.20833 10.8258 14.9158 5.45096 22.9274 0.785928V0.68457Z",
    fill: "url(#paint6_linear_6106_154339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M67.6523 33.6441C68.1594 33.6441 68.6664 33.6441 69.1735 33.6441C72.723 31.1088 76.2726 28.5734 79.8221 26.0381C75.6641 28.472 71.7089 31.1087 67.6523 33.7455V33.6441Z",
    fill: "url(#paint7_linear_6106_154339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M76.7773 33.0351C77.4872 33.0351 78.2986 32.9337 79.0085 32.8323C82.9636 32.528 88.6428 28.8772 90.164 24.8206C90.3668 24.2122 90.5699 23.6036 90.6713 22.9951C86.1077 26.4432 81.4424 29.6885 76.7773 33.0351Z",
    fill: "url(#paint8_linear_6106_154339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M55.0733 34.0491C55.0733 34.0491 55.9861 33.2378 56.3917 32.9336C55.7832 33.3392 55.0733 33.7449 54.4648 34.0491C54.6677 34.0491 54.8705 34.0491 55.0733 34.0491Z",
    fill: "url(#paint9_linear_6106_154339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M79.7177 1.49556H79.6165C59.131 10.42 39.6595 21.6768 20.5938 33.4408C21.4051 33.4408 22.3176 33.4407 23.2303 33.5421C31.749 27.7616 40.8764 22.691 49.6994 17.6203C59.5365 11.9411 69.6778 6.76896 79.7177 1.39404V1.49556Z",
    fill: "url(#paint10_linear_6106_154339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M36.7148 34.0493C37.8304 34.0493 38.9458 34.0493 40.0614 34.0493C44.1179 30.9055 48.3773 27.9646 52.7381 25.125C47.3631 28.066 42.0899 31.0069 36.8164 34.0493H36.7148Z",
    fill: "url(#paint11_linear_6106_154339)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_14",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.57
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58975 8.08772C12.0802 2.7128 20.7004 2.20568 28.712 1.69861C38.5492 1.09013 48.3863 1.19164 58.2234 1.80012C62.1786 2.00295 66.0323 2.30721 69.9875 2.61145C73.3341 2.81428 76.6809 3.11847 79.9261 3.82836C83.6784 4.63967 87.0249 6.16085 89.8644 8.39194C87.9376 4.74106 82.7655 1.59726 79.1146 1.29302C57.0065 -0.431008 34.797 -0.431008 12.6888 1.29302C8.7337 1.59726 3.05447 5.24809 1.53327 9.30463C0.823375 11.4343 0.417671 13.6654 0.214844 15.7951C1.43181 12.8541 3.25734 10.116 5.69127 8.08772H5.58975Z",
    fill: "#AB7409"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6106_154339",
    x1: 38.549,
    y1: -14.4259,
    x2: 51.9356,
    y2: 44.0897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6106_154339",
    x1: 17.0416,
    y1: -9.45718,
    x2: 30.4282,
    y2: 48.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6106_154339",
    x1: 35.9064,
    y1: -13.818,
    x2: 49.2929,
    y2: 44.5961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6106_154339",
    x1: 66.8413,
    y1: -20.9174,
    x2: 80.3292,
    y2: 37.4968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6106_154339",
    x1: 60.6518,
    y1: -19.4968,
    x2: 74.0383,
    y2: 38.9173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6106_154339",
    x1: 23.4384,
    y1: -10.9782,
    x2: 36.9264,
    y2: 47.5374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6106_154339",
    x1: 7.81681,
    y1: -7.42847,
    x2: 21.2033,
    y2: 51.0869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6106_154339",
    x1: 62.2774,
    y1: -19.902,
    x2: 75.7651,
    y2: 38.6134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6106_154339",
    x1: 72.2136,
    y1: -22.2356,
    x2: 85.6002,
    y2: 36.2805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6106_154339",
    x1: 44.1205,
    y1: -15.5424,
    x2: 57.5071,
    y2: 42.7708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6106_154339",
    x1: 42.7019,
    y1: -15.4406,
    x2: 56.0885,
    y2: 43.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6106_154339",
    x1: 34.788,
    y1: -13.6145,
    x2: 48.1744,
    y2: 44.9004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHunterTourBtn);
export default __webpack_public_path__ + "static/media/hunter-tour-btn.1e3dcd72ffb0a500e80ca7dbf50567cd.svg";
export { ForwardRef as ReactComponent };